import React from 'react';
import { Link } from 'react-router-dom';

import app from '../assets/images/app.png';
import play from '../assets/images/play.png';
import phone from '../assets/images/phone/half-3.png';
import { FiSmartphone } from 'react-icons/fi';
import { Link as Link1 } from 'react-scroll';
import { useTranslation } from 'react-i18next';

export default function Download() {
  const { t } = useTranslation();

  return (
    <div className="container relative">
      <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
        <div className="lg:col-span-5 md:col-span-6">
          <div className="pt-6 px-6 rounded-2xl bg-indigo-500/5 dark:bg-indigo-500/10 shadow shadow-indigo-500/20">
            <img src={phone} alt="" />
          </div>
        </div>

        <div className="lg:col-span-7 md:col-span-6">
          <div className="lg:ms-10">
            <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
              {t('download.subtitle')}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t('download.title')}
            </h4>
            <p className="text-slate-400 max-w-xl mb-0">{t('download.description')}</p>

            <div className="my-6">
              <Link to="#" className="relative inline-block cursor-wait">
                <img src={app} className="h-12 inline-block m-1 opacity-50" alt="" />
                <span className="absolute -top-2 left-2 inline-flex items-center justify-center bg-amber-400 text-amber-900 text-xs font-semibold rounded-full px-2 py-0.5 shadow-md ring-1 ring-amber-300 dark:bg-amber-500 dark:text-gray-900">
                  {t('download.comingSoon')}
                </span>
              </Link>
              <Link to="#" className="relative inline-block cursor-wait">
                <img src={play} className="h-12 inline-block m-1 opacity-50" alt="" />
                <span className="absolute -top-2 left-2 inline-flex items-center justify-center bg-amber-400 text-amber-900 text-xs font-semibold rounded-full px-2 py-0.5 shadow-md ring-1 ring-amber-300 dark:bg-amber-500 dark:text-gray-900">
                  {t('download.comingSoon')}
                </span>
              </Link>
            </div>

            <div className="inline-block">
              <div className="pt-4 flex items-center border-t border-gray-100 dark:border-gray-800">
                <FiSmartphone className="me-2 text-indigo-500 size-10" />
                <div className="content">
                  <h6 className="text-base font-medium">{t('download.tryNow')}</h6>
                  <Link1
                    spy={true}
                    smooth={true}
                    duration={500}
                    to="contact"
                    className="hover:text-indigo-500 dark:hover:text-indigo-500 after:bg-indigo-500 dark:text-white transition duration-500 font-medium"
                  >
                    {t('download.testflight')} <i className="mdi mdi-arrow-right"></i>
                  </Link1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
